import React from 'react'
import TaskStatics from "../../../../components/crm/ReportTask"

function TaskStatistics() {
    return (
        <TaskStatics isTenant={true}/>
    )
}

export default TaskStatistics